import {
  ADD_REFERRAL,
  ADD_REFERRAL_SUCCESS,
  ADD_REFERRAL_FAIL,
  GET_REFERRAL,
  GET_REFERRAL_SUCCESS,
  GET_REFERRAL_FAIL,
  UPDATE_REFERRAL,
  UPDATE_REFERRAL_SUCCESS,
  UPDATE_REFERRAL_FAIL
} from "./actionTypes"

const INIT_STATE = {
  referrals: [],
  detail: {},
  error: {},
}

const affiliate = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_REFERRAL_SUCCESS:
      return {
        ...state,
        referral: action.payload,
      }

    case ADD_REFERRAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
		  
    case GET_REFERRAL_SUCCESS:
      return {
        ...state,
        referral: action.payload,
      }

    case GET_REFERRAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case UPDATE_REFERRAL_SUCCESS:
      return {
        ...state,
        referral: action.payload,
      }

    case UPDATE_REFERRAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default affiliate
